/**
 * @generated SignedSource<<005b56e5adb5204d58b4ae4e00d487b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TestScopesView$data = {
  readonly nextHref: string | null | undefined;
  readonly testScope: ReadonlyArray<{
    readonly class: string | null | undefined;
    readonly package: string | null | undefined;
    readonly suite: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"TestScope">;
  }> | null | undefined;
  readonly " $fragmentType": "TestScopesView";
};
export type TestScopesView$key = {
  readonly " $data"?: TestScopesView$data;
  readonly " $fragmentSpreads": FragmentRefs<"TestScopesView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TestScopesView",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextHref",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TestScope",
      "kind": "LinkedField",
      "name": "testScope",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "suite",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "package",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "class",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TestScope"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TestScopes",
  "abstractKey": null
};

(node as any).hash = "989c1e77573eaa84e289173b46652e8d";

export default node;
